import React from 'react';
import '../LinkedInTheme.css';

const Logo = ({ size = 24, className = '', style = {} }) => {
  const brandColor = '#0a66c2';
  
  return (
    <div 
      className={`logo ${className}`} 
      style={{ 
        fontSize: `${size}px`, 
        fontWeight: 'bold', 
        color: brandColor,
        display: 'inline-flex',
        alignItems: 'center',
        lineHeight: 1,
        userSelect: 'none',
        ...style
      }}
    >
      <style>
        {`
          .logo:hover .pod-plus-icon {
            transform: rotate(90deg);
          }
        `}
      </style>
      POD
      <span 
        className="pod-plus-icon"
        style={{ 
          display: 'inline-block',
          position: 'relative',
          width: '0.7em',
          height: '0.7em',
          marginLeft: '0.1em',
          color: 'inherit',
          transition: 'transform 0.3s ease-in-out'
        }}
      >
        <span style={{
          position: 'absolute',
          top: '50%',
          left: 0,
          width: '100%',
          height: '0.15em',
          marginTop: '-0.075em',
          backgroundColor: 'currentColor',
          borderRadius: '2px'
        }}></span>
        <span style={{
          position: 'absolute',
          top: '50%',
          left: 0,
          width: '100%',
          height: '0.15em',
          marginTop: '-0.075em',
          backgroundColor: 'currentColor',
          borderRadius: '2px',
          transform: 'rotate(90deg)'
        }}></span>
      </span>
    </div>
  );
};

export default Logo;
